import React, { useState } from "react";
import Modal from "components/modal";
import Image from "components/image";
import QuantityPicker from "components/product/quantity-picker";
import { useCart } from "hooks/useStore";
import useToggle from "hooks/useToggle";
import clsx from "clsx/lite";
import Loader from "components/loader";
import Money from "components/money";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import Link from "components/link";
import { trackAddToCartWarranty } from "analytics";
import { updateCloseCount } from "helpers/warranty";
import usePostATCAction from "hooks/usePostATCAction";

const WarrantyModal = ({ product, isOpen, toggleModal }) => {
	const [quantity, setQuantity] = useState(1);
	const [isLoading, toggleLoading] = useToggle();
	const { addCartItem } = useCart(["addCartItem"]);
	const postAddToCartAction = usePostATCAction();

	const variant = product.variant;

	const handleAddToCart = async () => {
		if (!variant.isAvailable || isLoading) return;
		toggleLoading();
		await addCartItem(variant.gid, quantity);
		trackAddToCartWarranty(product);
		toggleLoading();
		toggleModal();
		postAddToCartAction();
	};

	const handleClose = () => {
		toggleModal();
		postAddToCartAction();
		updateCloseCount();
	};

	return (
		<Modal
			isOpen={isOpen}
			close={handleClose}
			hideHeader
			className="text-center w-11/12 md:!max-w-screen-lg !max-h-full"
		>
			<div className="flex flex-col md:flex-row p-4 gap-2 md:p-8 md:gap-8 w-full relative">
				<Link to={`/products/${product?.handle}`}>
					<Image image={product?.images?.[0]} className="w-full md:w-96 h-64 md:h-auto *:object-top" />
				</Link>
				<button className="absolute top-8 right-8 bg-cream p-4 md:hidden translate-z-1 z-10"
					onClick={handleClose}>
					<Close className="size-4" />
				</button>
				<div className="flex-1 flex flex-col md:justify-between">
					<div>
						<h4 className="text-start uppercase md:pb-1 md:text-h3">Enjoy peace of mind!</h4>
						<p className="text-sm text-start text-secondary">With our 2-Year Extended Warranty!</p>
					</div>
					<p className="text-left my-2 md:my-6 text-sm md:text-base">
						Get extended coverage with our 2-Year Extended Warranty.
						If something goes wrong, contact our customer support 24/7,
						and we’ll repair or replace your light for free.
					</p>
					<div className="flex justify-between items-center">
						<div className="flex flex-col items-start">
							<p className="font-semibold mb-2">Quantity</p>
							<QuantityPicker config={{ quantity, setQuantity }} />
						</div>
						<div className="flex flex-col items-end gap-1">
							<p className="text-secondary text-end">{product.title}</p>
							<p className="text-2xl md:text-3xl font-semibold">
								<Money value={variant.price} markets={variant.markets} />
							</p>
						</div>
					</div>
					<div className="flex gap-3.5 pt-2 md:pt-8">
						<button
							disabled={!variant.isAvailable || isLoading}
							className={
								clsx("w-full py-3 btn-primary text-base tracking-widest px-2",
									isLoading && "pointer-events-none")}
							onClick={handleAddToCart}
						>
							{isLoading
								? <Loader className="size-5" ring />
								: "Add to cart"}
						</button>
						<button
							className="hidden md:flex btn-primary text-black bg-cream hover:bg-cream"
							onClick={handleClose}
						>Close</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};


export default WarrantyModal;
